import { useMemo } from "react";

import { floatRounding } from "../../../../utils/utils";
import { CellText } from "./cell-text";

export function CellNumber<T>(props: {
  item: T;
  attr: keyof T;
  patch?: any;
  index: () => number;
  precision?: number;
}) {
  const displayValue = useMemo(() => {
    const raw = props.item[props.attr];
    return props.precision !== undefined
      ? floatRounding(raw as number, props.precision)
      : raw;
  }, [props.item, props.attr, props.precision]);

  return <CellText {...props} width={50} displayValue={displayValue} />;
}
